import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LuChevronDown } from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';

const faqs = [
  {
    q: "Berapa lama estimasi waktu pengiriman reguler?",
    a: "Estimasi waktu pengiriman reguler (G-Reg) bervariasi antara 2-4 hari kerja tergantung pada jarak dan lokasi tujuan pengiriman Anda."
  },
  {
    q: "Apakah barang saya diasuransikan?",
    a: "Ya, kami menyediakan opsi asuransi untuk setiap pengiriman. Untuk barang bernilai tinggi, kami sangat menyarankan Anda untuk mengaktifkan layanan asuransi ini."
  },
  {
    q: "Bagaimana cara saya melacak paket?",
    a: "Anda dapat melacak paket secara real-time melalui fitur 'Lacak Paket' di website kami dengan memasukkan nomor resi yang diberikan saat pendaftaran pengiriman."
  },
  {
    q: "Apakah melayani pengiriman ke luar pulau?",
    a: "Tentu. Kami memiliki jaringan kargo darat, laut, dan udara yang terintegrasi untuk melayani pengiriman dari dan ke seluruh pulau di Indonesia."
  },
  {
    q: "Bagaimana prosedur layanan pindahan (Relokasi)?",
    a: "Setelah Anda menghubungi kami, tim surveyor akan datang untuk menilai volume barang. Setelah harga disepakati, tim kami akan datang pada hari H untuk melakukan proses packing, loading, pengiriman, hingga unloading di lokasi baru."
  }
];

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <section id="faq" className="py-24 bg-light">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy mb-4">Pertanyaan Seputar Layanan</h2>
          <div className="w-20 h-1.5 bg-orange mx-auto rounded-full"></div>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <motion.div 
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              key={index} 
              className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100"
            >
              <button 
                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none"
              >
                <span className="font-heading font-semibold text-navy text-lg pr-4">{faq.q}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${activeIndex === index ? 'bg-orange text-white' : 'bg-gray-100 text-gray-500'}`}>
                  <motion.div animate={{ rotate: activeIndex === index ? 180 : 0 }}>
                    <SafeIcon icon={LuChevronDown} className="w-5 h-5" />
                  </motion.div>
                </div>
              </button>
              
              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <div className="px-6 pb-5 text-gray-600 border-t border-gray-50 pt-3 leading-relaxed">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}